import React from 'react'
import { useAdminFilter } from './AdminFilterContext'
import { rangeLabel } from './dateRange'
import { StatCard, StatGroup, StatLabel, StatValue } from './ListStats.styles'

interface ListStatsProps {
	/** Plural noun for the resource, e.g. "users", "trips", "payups". */
	noun: string
	/** All-time grand total (ignores the date range). */
	total: number
	/** Count created within the selected date range. */
	newInRange: number
}

/**
 * The header shown above each admin list: the all-time `total` for the resource and
 * the `newInRange` count added within the globally-selected date range (labelled with
 * the active preset, e.g. "New · last 30 days"). Reused across every list page so the
 * two numbers read the same everywhere.
 */
const ListStats: React.FC<ListStatsProps> = ({ noun, total, newInRange }) => {
	const { from, to } = useAdminFilter()

	return (
		<StatGroup>
			<StatCard>
				<StatValue>{total.toLocaleString()}</StatValue>
				<StatLabel>Total {noun}</StatLabel>
			</StatCard>
			<StatCard>
				<StatValue>{newInRange.toLocaleString()}</StatValue>
				<StatLabel>New · {rangeLabel(from, to)}</StatLabel>
			</StatCard>
		</StatGroup>
	)
}

export default ListStats
